/* eslint camelcase: "off" */
import React, { Fragment } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Cell from './Cell'
import fillNullCashflowData from './helpers/fillNullCashflowData'
import borrowerTypes from './helpers/borrowerTypes'

const Container = styled.div`
  background: white;
  display: flex;
  flex-direction: column;
  border: 2px solid #eeeeee;
  margin-top: 9px;
`
const Row = styled.div`
  font-weight: ${props => props.bold ? 'bold' : 'normal'};
  color: white;
  display: grid;
  grid-template-columns: 3fr 1fr 1fr 1fr 1fr 1fr;
  background: #40bac9;
  border-top: ${props => props.border ? '9px solid #f8f8f8' : 'none'};
  padding-right: 10px;
  padding-left: 0px;
  &:nth-of-type(odd) {
    padding-top: 10px;
  }
  &:nth-of-type(even) {
    padding-bottom: 10px;
  }
`
const Title = styled.div`
  text-align: right;
`
const DSCRCell = styled.div`
  text-align: right;
`
export default class DSCRFooter extends React.Component {
  renderBusinessCellsByKey = (rid, key) => {
    const { years, businesses } = this.props
    const business = businesses.find(b => b.rid === rid)
    const { cashflowData } = business
    const data = cashflowData.filter(datum => datum.category === key && years.has(datum.year))
    return fillNullCashflowData(data, years, { key }).map(datum => {
      return (
        <DSCRCell key={`${datum.category}-${datum.year}`}>
          {typeof datum.data === 'number' ? datum.data.toFixed(2) : datum.data}
        </DSCRCell>
      )
    })
  }
  renderLoanCellsByKey = key => {
    const { years } = this.props
    const { cashflowData } = this.props.loan
    const data = cashflowData.filter(datum => datum.category === key && years.has(datum.year))
    return fillNullCashflowData(data, years, { key }).map(datum => {
      return (
        <DSCRCell key={`${datum.category}-${datum.year}`}>
          {typeof datum.data === 'number' ? datum.data.toFixed(2) : datum.data}
        </DSCRCell>
      )
    })
  }
  renderBusinessDSCRs = () => {
    const { businesses } = this.props
    const borrowerTypeCounts = {}
    for (const business of businesses) {
      const { borrowerType } = business
      if (!(borrowerType in borrowerTypeCounts)) {
        borrowerTypeCounts[borrowerType] = 0
      }
    }
    return businesses.map(business => {
      const { borrowerType } = business
      borrowerTypeCounts[borrowerType] += 1
      const num = borrowerTypeCounts[borrowerType]
      return (
        <Fragment key={business.rid}>
          <Row bold>
            <Title>
              {`${borrowerTypes[borrowerType]} ${borrowerType === 'oc' ? '' : `${num} -`} Debt Service Coverage Ratio (DSCR)`}
            </Title>
            {this.renderBusinessCellsByKey(business.rid, 'business_dscr')}
          </Row>
          <Row>
            <Title>{`${borrowerTypes[borrowerType]} ${borrowerType === 'oc' ? '' : `${num} -`} DSCR - 2% Stressed`}</Title>
            {this.renderBusinessCellsByKey(business.rid, 'stressed_business_dscr')}
          </Row>
        </Fragment>
      )
    })
  }
  render() {
    return (
      <Container>
        {this.renderBusinessDSCRs()}
        <Row bold border>
          <Title>Global Debt Service Coverage Ratio (DSCR)</Title>
          {this.renderLoanCellsByKey('global_dscr')}
        </Row>
        <Row>
          <Title>Global DSCR - 2% Stressed</Title>
          {this.renderLoanCellsByKey('stressed_global_dscr')}
        </Row>
      </Container>
    )
  }
}

DSCRFooter.propTypes = {
  years: PropTypes.object.isRequired
}
